import {LinkType} from '@workspaces/link';

export const adminLinks: LinkType = {
  PROD: 'https://app.bdes-online.fr/admin/',
  PREPROD: 'https://app-preprod.bdes-online.fr/admin/',
  DEV: 'https://app-preprod.bdes-online.fr/admin/',
  LOCAL: 'https://bdese.tissot-local.com/admin/',
};

export const appLinks: LinkType = {
  PROD: 'https://app.bdes-online.fr/',
  PREPROD: 'https://app-preprod.bdes-online.fr/',
  DEV: 'https://app-preprod.bdes-online.fr/',
  LOCAL: 'https://bdese.tissot-local.com/',
};
